module.exports = __webpack_public_path__ + "img/incae.1e0fb496.png";